import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobRoutingModule } from './job-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    JobRoutingModule
  ]
})
export class JobModule { }
